var _a;

import debug from 'debug';
import isServer from './utils/is-server';
const rootNamespace = 'sitecore-jss'; // On server/node side, allow switching from the built-in
// `%o` (pretty-print single line) and `%O` (pretty-print multiple line)
// with a `DEBUG_MULTILINE` environment variable.

if (isServer() && ((_a = process === null || process === void 0 ? void 0 : process.env) === null || _a === void 0 ? void 0 : _a.DEBUG_MULTILINE) === 'true' && debug.formatters.o && debug.formatters.O) {
  debug.formatters.o = debug.formatters.O;
}
/**
 * Default Sitecore JSS 'debug' module debuggers. Uses namespace prefix 'sitecore-jss:'.
 * See {@link https://www.npmjs.com/package/debug} for details.
 */


export default Object.freeze({
  http: debug(`${rootNamespace}:http`),
  layout: debug(`${rootNamespace}:layout`),
  dictionary: debug(`${rootNamespace}:dictionary`),
  experienceEditor: debug(`${rootNamespace}:editing`),
  sitemap: debug(`${rootNamespace}:sitemap`)
});